/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadDefinition extends models.BaseDefinition {
    getFixupPrototypeFunction() { return WorkloadDefinition.fixupPrototype; }

    static newInstance(model: Partial<WorkloadDefinition>): WorkloadDefinition {
        let obj = Object.assign(new WorkloadDefinition(), model);
        WorkloadDefinition.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadDefinition>): WorkloadDefinition {
        if (!model) return null;
        return WorkloadDefinition.newInstance(<WorkloadDefinition> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadDefinition) {
        if (!obj) return;

        models.WorkloadDefinition.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadDefinition): boolean {
        if (models.BaseDefinition.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, WorkloadDefinition.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant owning the workload
     */
    tenant_id: string;

    /**
     * Owner of the workload
     */
    owner: string;

    /**
     * Name of the workload
     */
    name: string;

    /**
     * Description of the workload
     */
    description: string;

    /**
     * Type of the workload
     */
    workload_type: string;

    /**
     * States if the workload is active or not
     */
    is_active: boolean;

    /**
     * List of attachment IDs associated with this workload
     */
    attachments: Array<string>;

}
